<template>
  <div>
      <div class="page_footer content">
        <!-- <div class="top_header_box2 ">
            <img :src='headerLogoAddress+headerLogo' alt="" >
            <div class="line_box">
                <p class="header_title_page">
                    <img src="../../../../../public/imgs/cepingreport/page_feng.png" alt="">
                    目录
                </p>
            </div>
        </div> -->
        <h5 class="career_page header_title_page">后记</h5>
        <p>一个人若是看不到未来，就掌握不了现在；一个人若是掌握不了现在，就看不到未来。究其本质，生涯规划的精髓就在于：立足现在，胸怀未来。</p>
        <p>本生涯测评从当前出发，帮助你在人格、能力和职业倾向方面进行自我探索，并借助系统、科学的理论和方法完成专业、职业匹配与推荐，为你的生涯定向和规划提供明确指引。</p>
        <p>对于绝大多数人而言，生涯规划是一个需要在各个人生阶段不断探索、尝试和调整的过程。本测评给你带来发展方向的同时，也提示你掌握当下，不要完全放弃发掘、尝试更多的可能路径，同时牢记生涯目标的实现要回归到现实的投入，以实际成绩和成果为通行证，才能更好地开启理想人生。</p>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.page_footer{
  box-sizing: border-box;
    background-color: #fff;
    /* padding: 80px 90px;
    width: 900px; */
    height: 1000px;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
}
.page_footer h5{
  font-size: 20px;
  font-weight: 600;
}
.page_footer p{
  font-size: 14px;
  text-indent: 2em;
  line-height: 2;
}
</style>